import React from 'react'
import { LeftArrowIcon, RightArrowIcon } from '@ow/icons'
import PropTypes from 'prop-types'
import { toNumber } from 'lodash-es'
import StyledContent from './styled/showAndChangeDate'

const ShowAndChangeDate = (props) => {
  const { currentDate, changeDate } = props
  const currentYear =
    currentDate && currentDate.split('-')[0]
      ? currentDate.split('-')[0]
      : new Date().getFullYear()
  const currentMonth =
    currentDate && currentDate.split('-')[1]
      ? currentDate.split('-')[1]
      : new Date().getMonth() + 1

  return (
    <StyledContent>
      <div>
        {currentYear}年{currentMonth}月
      </div>
      <div className="btn-group">
        <div
          className="btn"
          onClick={() => {
            const preMonth =
              toNumber(currentMonth) - 1 === 0 ? 12 : toNumber(currentMonth) - 1
            let perYear = toNumber(currentYear)
            if (preMonth === 12) {
              perYear -= 1
            }
            changeDate(
              `${perYear}-${preMonth < 10 ? `0${preMonth}` : preMonth}`
            )
          }}
        >
          <LeftArrowIcon fill="#8094ae" />
        </div>
        <div
          className="btn"
          onClick={() => {
            const nextMonth =
              toNumber(currentMonth) + 1 === 13 ? 1 : toNumber(currentMonth) + 1
            let nextYear = toNumber(currentYear)
            if (nextMonth === 1) {
              nextYear += 1
            }
            changeDate(
              `${nextYear}-${nextMonth < 10 ? `0${nextMonth}` : nextMonth}`
            )
          }}
        >
          <RightArrowIcon fill="#8094ae" />
        </div>
      </div>
    </StyledContent>
  )
}

ShowAndChangeDate.propTypes = {
  currentDate: PropTypes.string.isRequired,
  changeDate: PropTypes.func.isRequired,
}
export default ShowAndChangeDate
